import { useContext } from 'react';
import { View } from '@shared/components/View';
import { MBIconV2 } from '@shared/components/image';
import { MBTouchableOpacity } from '@shared/components/touchable';
import { MBTextBody1 } from '@shared/components/typography';
import { ColorThemeContext } from '@shared/styles';
import { i18n } from '@shared/util/i18n';

interface Props {
  onAdd(): void;
}

export function MBCardInputBlockReminderAddRow({ onAdd }: Props) {
  const colors = useContext(ColorThemeContext);
  return (
    <MBTouchableOpacity onPress={onAdd}>
      <View row centerVertically paddingHorizontal={3} paddingBottom={3}>
        <MBIconV2 name="plus-circle" color={colors.accent} />
        <View paddingRight={2} />
        <MBTextBody1 color={colors.foregroundInactive}>
          {i18n('card.blocks.reminder.addLabel')}
        </MBTextBody1>
      </View>
    </MBTouchableOpacity>
  );
}
